<script setup>
  import InfoBlock from '@/components/InfoBlock.vue';
  import { computed } from 'vue';

  defineProps({
    steps: {
      type: Number,
      default: 0,
    },
  });

  const emit = defineEmits(['gotoStep']);

  // Use the main website URL (www) for documentation link
  const docsUrl = computed(() => {
    return window.viploge?.urls?.website
      ? `${window.viploge.urls.website}/nl/docs`
      : '/nl/docs';
  });
</script>

<template>
  <div class="mb-4 flex items-center justify-between">
    <h1 class="text-lg lg:text-xl xl:text-2xl font-bold text-gray-900">
      {{ $t('auth.registration.info_step.create_account') }}
    </h1>
    <span class="text-xs lg:text-sm text-gray-400">(1/{{ steps }})</span>
  </div>

  <InfoBlock
    :cta="$t('message.manual.description')"
    width="w-full"
    :url="docsUrl"
  />

  <div
    class="mb-4 inline-block w-full text-sm text-gray-500"
    v-html="$t('auth.registration.info_step.terms_and_information')"
  ></div>

  <div class="mt-6">
    <p class="text-sm font-bold">
      {{ $t('auth.registration.info_step.i_understand') }}
    </p>
    <button
      class="btn-primary !rounded-full !px-5 !py-3 mt-5 text-sm w-full flex items-center justify-center whitespace-normal"
      type="button"
      @click="emit('gotoStep', 2)"
    >
      <span>{{ $t('auth.registration.info_step.create_my_account') }}</span>
      <span class="ml-2"><i class="fa-regular fa-arrow-right"></i></span>
    </button>
  </div>
</template>
